var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('table-parcelas',{attrs:{"empresa":this.empresa,"num_venda":this.num_venda,"obra":this.obra,"empreendimento":this.empreendimento,"identificador":this.identificador}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }